import { Currency } from "../utils/Currency";
import { DateUtil } from "../utils/DateUtil";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isBetween from "dayjs/plugin/isBetween";
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(isBetween);
export class TermInterestAmountOverride {
    _termNumber;
    jsTermNumber;
    _interestAmount;
    jsInterestAmount;
    _active = true;
    jsActive = true;
    _acceptableRateVariance = 0.01; // 1%
    jsAcceptableRateVariance = 0.01; // 1%
    _date;
    jsDate;
    constructor(params) {
        this.termNumber = params.termNumber;
        this.interestAmount = params.interestAmount;
        this.date = params.date;
        if (params.active !== undefined) {
            this.active = params.active;
        }
        if (params.acceptableRateVariance) {
            this.acceptableRateVariance = params.acceptableRateVariance;
        }
    }
    get acceptableRateVariance() {
        return this._acceptableRateVariance;
    }
    set acceptableRateVariance(value) {
        this._acceptableRateVariance = value;
        this.jsAcceptableRateVariance = value;
    }
    get active() {
        return this._active;
    }
    set active(value) {
        this._active = value;
        this.jsActive = value;
    }
    get termNumber() {
        return this._termNumber;
    }
    set termNumber(value) {
        this._termNumber = value;
        this.jsTermNumber = value;
    }
    get date() {
        return this._date;
    }
    set date(value) {
        if (value) {
            this._date = DateUtil.normalizeDate(value);
            this.jsDate = DateUtil.normalizeDateToJsDate(this._date);
        }
        else {
            this._date = undefined;
            this.jsDate = undefined;
        }
    }
    get interestAmount() {
        return this._interestAmount;
    }
    set interestAmount(value) {
        this._interestAmount = new Currency(value);
        this.jsInterestAmount = this._interestAmount.toNumber();
    }
    updateModelValues() {
        this.termNumber = this.jsTermNumber;
        this.interestAmount = this.jsInterestAmount;
        this.date = this.jsDate;
        this.active = this.jsActive;
        this.acceptableRateVariance = this.jsAcceptableRateVariance;
    }
    updateJsValues() {
        this.jsTermNumber = this.termNumber;
        this.jsInterestAmount = this.interestAmount.toNumber();
        if (this.date) {
            this.jsDate = DateUtil.normalizeDateToJsDate(this.date);
        }
        else {
            this.jsDate = undefined;
        }
        this.jsActive = this.active;
        this.jsAcceptableRateVariance = this.acceptableRateVariance;
    }
    get json() {
        return {
            termNumber: this.termNumber,
            interestAmount: this.interestAmount.toNumber(),
            acceptableRateVariance: this.acceptableRateVariance,
            date: this.date?.toString(),
            active: this.active,
        };
    }
}
